export const RouteEnum = {
  HOME: "/",
  // DASHBOARD: "/",
  LOGIN: "/login",
  SCHOLARSHIPS: "/scholarships",
  INVEST: "/invest",
  SIGNUP: "/signup",
  DASHBOARD: "/dashboard",
  CONTRIBUTION: "/contribution",
  LANDING: "/",
  WHATWEDO: "/what-we-do",
  OURVALUES: "/our-values",
  TEAM: "/team",
  STORY: "/about",
  HOWITWORKS: "/how-it-works",
  CAREERS: "/careers",
  SETTINGS: "/settings",
  USERMANAGEMENT: "/user-management",

  GRANT: "/grant",
  PROFILE: "/profile",
  CAMPAIGN: "/campaigns",
  LOAN: "/loan",
  VERIFYACCOUNT: "/verify-account",

  ABOUT: "/about",
  CONTACTUS: "/contact-us",
  RECRUITERS: "/recruiters",
  ASSESSMENT: "/assessment",
  JOB_SEEKERS: "/job-seekers",
  FAQ: "/faq",
  CONTACT_US: "/contact-us",
  CREATE_ACCOUNT: "/create-account",
  PROTECTED: "/admin/dashboard",
  PROTECTED_USER: "/user/dashboard",
  FORGOT_PASSWORD: "/forgot-password",
  JOB_SEARCH: "/jobs",
  SUPER_ADMIN: "/super-admin/dashboard",
};
